import { render, staticRenderFns } from "./icv2_summary_report.vue?vue&type=template&id=4e65c560&"
import script from "./icv2_summary_report.vue?vue&type=script&lang=js&"
export * from "./icv2_summary_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports